var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruck2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 3.5V12.5C15.5 13.6 14.6 14.5 13.5 14.5H2.5V6.5C2.5 4.29 4.29 2.5 6.5 2.5H14.5C15.05 2.5 15.5 2.95 15.5 3.5Z",
    fill: "#2A2D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.5 14.5V17.5C22.5 19.16 21.16 20.5 19.5 20.5H18.5C18.5 19.4 17.6 18.5 16.5 18.5C15.4 18.5 14.5 19.4 14.5 20.5H10.5C10.5 19.4 9.6 18.5 8.5 18.5C7.4 18.5 6.5 19.4 6.5 20.5H5.5C3.84 20.5 2.5 19.16 2.5 17.5V14.5H13.5C14.6 14.5 15.5 13.6 15.5 12.5V5.5H17.34C18.06 5.5 18.72 5.89001 19.08 6.51001L20.79 9.5H19.5C18.95 9.5 18.5 9.95 18.5 10.5V13.5C18.5 14.05 18.95 14.5 19.5 14.5H22.5Z",
    fill: "#2A2D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 22.5C9.60457 22.5 10.5 21.6046 10.5 20.5C10.5 19.3954 9.60457 18.5 8.5 18.5C7.39543 18.5 6.5 19.3954 6.5 20.5C6.5 21.6046 7.39543 22.5 8.5 22.5Z",
    fill: "#2A2D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 22.5C17.6046 22.5 18.5 21.6046 18.5 20.5C18.5 19.3954 17.6046 18.5 16.5 18.5C15.3954 18.5 14.5 19.3954 14.5 20.5C14.5 21.6046 15.3954 22.5 16.5 22.5Z",
    fill: "#2A2D32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 13.03V14.5H19.5C18.95 14.5 18.5 14.05 18.5 13.5V10.5C18.5 9.95 18.95 9.5 19.5 9.5H20.79L22.24 12.04C22.41 12.34 22.5 12.68 22.5 13.03Z",
    fill: "#2A2D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck2);
export default __webpack_public_path__ + "static/media/truck2.98e4eb58a03faa9500aaf7f97dfd6835.svg";
export { ForwardRef as ReactComponent };